import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../../constants/axiosInstance';
import { BatchConfiguration } from '../types/BatchConfigType';

const fetchBatchConfigurationDetails = async (batchId: string): Promise<BatchConfiguration> => {
  const { data } = await axiosInstance().post(
    `/batch/getBatchConfigDetails`,{batchId: batchId}
  );
  return data?.data;
};

export const useBatchConfigurationDetails = (batchId: string) => {
  const {
    data: batchConfigurationDetails,
    isLoading: isBatchConfigurationDetailsLoading,
    error: batchConfigurationDetailsError,
    refetch: refetchBatchConfigurationDetails,
  } = useQuery({
    queryKey: ['batchConfigurationDetails', batchId],
    queryFn: () => fetchBatchConfigurationDetails(batchId),
    enabled: !!batchId,
    refetchOnMount: true, 
    staleTime: 0,
    refetchOnWindowFocus: false,
  });

  return {
    batchConfigurationDetails,
    isBatchConfigurationDetailsLoading,
    batchConfigurationDetailsError,
    refetchBatchConfigurationDetails,
  };
};
